import { Component, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
declare let jQuery: any;

@Component({
  selector: 'header',
  templateUrl: 'header.component.html',
  standalone: true
})
export class HeaderComponent implements AfterViewInit {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngAfterViewInit() {
    const isBrowser = isPlatformBrowser(this.platformId);
    if (isBrowser) {
      const prefix = isBrowser ? '' : '/';
      jQuery(document).ready(function () {
        jQuery('.header_content').load(prefix + 'assets/header.html');
      });
    }
  }
}
